import { Controller } from "@hotwired/stimulus"
import flatpickr from "flatpickr"
import "flatpickr/dist/flatpickr.css"

export default class extends Controller {
  static targets = ["input", "unit", "syncFooter"]
  static values = { urlTemplate: String }

  connect() {
    this.reservationDates = []
    this.flatpickr = flatpickr(this.inputTarget, {
      disableMobile: true,
      onDayCreate: (_selectedDates, _dateString, instance, dayElement) => this.shadeReservationDate(instance, dayElement),
      onReady: (_selectedDates, _dateString, instance) => instance.calendarContainer.append(this.syncFooterTarget.content.cloneNode(true))
    })
    this.load()
  }

  disconnect() {
    this.flatpickr.destroy()
  }

  async load() {
    const unitId = this.unitTarget.value
    if (!unitId) {
      this.reservationDates = []
      this.flatpickr.redraw()
      return
    }

    const response = await fetch(this.urlTemplateValue.replace("UNIT_PLACEHOLDER", unitId))
    const { reservation_dates } = await response.json()
    if (!this.element.isConnected || unitId !== this.unitTarget.value) return

    this.reservationDates = reservation_dates
    this.flatpickr.redraw()
  }

  shadeReservationDate(instance, dayElement) {
    const date = instance.formatDate(dayElement.dateObj, "Y-m-d")
    const reservation = this.reservationDates.find(
      ({ start_date, last_night }) => start_date <= date && date <= last_night
    )
    if (!reservation) return

    dayElement.classList.add("reservation-date")
    dayElement.setAttribute("aria-label", `${dayElement.getAttribute("aria-label")}, reserved`)

    if (date === reservation.start_date || dayElement.$i % 7 === 0) {
      dayElement.classList.add("reservation-range-start")
    }

    if (date === reservation.last_night || dayElement.$i % 7 === 6) {
      dayElement.classList.add("reservation-range-end")
    }
  }
}
